import { useSelector } from 'react-redux';
import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as VatReturnService from 'services/api/vatreturn_list';
interface VatReturnListElement {
  applicant_username: string;
  vat_return_id: number;
  vat_return_version_id: number;
  quarter_id: number;
  ending_month: number;
  short_text: string;
  starting_month: number;
  year: number;
  period_start_date: Date;
  period_end_date: Date;
  vat_return_reference: string;
  vat_return_status_id: number;
  vat_return_status_description: string;
  is_sent: number;
  vat_return_state: string;
  submission_date: Date;
  vat_return_due_date: Date;
  vat_id_num: string;
  is_nill: number;
  is_updated: number;
  can_be_updated: number;
  version: Date;
  modified_by: string;
  modified_at: Date;
  vat_amount: number;
  paid_amount: number;
  allocated_amount: number;
  reimbursed_amount: number;
}

interface VatReturnListPaging {
  page: number;
  pageSize: number;
  total: number;
}
interface VatReturnListData {
  paging: VatReturnListPaging;
  items: VatReturnListElement[];
}

interface VatReturnListOutput {
  status: StateStatus;
  data: VatReturnListData | null;
}

export const useGetVatReturnList = (): VatReturnListOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].vatReturnList
  );
  return data;
};

interface VatReturnListAllData {
  vat_return_id: number;
  vat_return_ref: string;
}

interface VatReturnListAllOutput {
  data: VatReturnListAllData[] | null;
}

export const useGetVatReturnListAll = (): VatReturnListAllOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].vatReturnListAll
  );
  return data;
};

// SCHEME TYPES
interface ISchemeTypesData {
  applicant_type_id: number;
  code: 'EU' | 'NON_EU' | 'IOSS';
  description: string;
}

interface ISchemeTypesDataOutput {
  status: StateStatus;
  data: Array<ISchemeTypesData>;
}

export const useGetSchemeTypes = (): ISchemeTypesDataOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].schemeTypesList
  );
  return data;
};

interface IQuarter {
  quarter_id: number;
  starting_month: number;
  ending_month: number;
  short_text: string;
}

interface IQuarterDataOutput {
  status: StateStatus;
  data: Array<IQuarter>;
}
export const useGetQuarters = (): IQuarterDataOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].quarterList
  );
  return data;
};

export const useGetMonthQuarterList = (): IQuarterDataOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].monthQuarterList
  );
  return data;
};

interface IUserInfoForVATReturnCreation {
  active_registrations: Array<any>;
  scheme_type: number;
  vat_id_num: string;
}
interface IUserInfoForVATReturnCreationOutput {
  data: IUserInfoForVATReturnCreation;
  status: StateStatus;
}

export const useGetUserInfoForVatReturnCreation =
  (): IUserInfoForVATReturnCreationOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.VATRETURN_LIST_REDUCER].vatCreationUserInfo
    );
    return data;
  };

export const useGetAddVatReturnPaymentStatus = (): StateStatus => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.VATRETURN_LIST_REDUCER].addVatReturnPaymentStatus
  );
  return data;
};

export const useGetAddVatReturnPaymentResponse = (): StateStatus => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.VATRETURN_LIST_REDUCER].addVatReturnPaymentRespone
  );
  return data;
};

interface IAgentTradersOutput {
  data: Array<VatReturnService.ITradersInfo>;
  status: StateStatus;
}

export const useGetAgentTraders = (): IAgentTradersOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.VATRETURN_LIST_REDUCER].agentTraders
  );
  return data;
};
